/*
 * @Description:
 * @Date: 2020-11-03 09:41:19
 */
import { getToken, setToken } from '@/tools/auth';
import { getStorage, setStorage } from '@/tools/storage';
// import { baseConfig, biTmplIsHidden, zsManageIsHidden } from '@/api/ajax';
import { baseConfig, zsManageIsHidden } from '@/api/ajax';

import qiankunStore from '@/qiankun/store'; // qiankun
import { pageList } from '@/common/data-source/company-crm/apis';

const disIds = [];

// store
export const baseMenu = [
  { label: '首页', name: 'home', weight: 1 },
  { label: '下载中心', name: 'downloadList', weight: 2 },
  { label: '结算中心', name: 'account', weight: 3 },
  { label: '自然人信息管理', name: 'infoManageIndex', weight: 4 },
  { label: '材料下载', name: 'material-download-list', weight: 12 }
];
export const masterMenu = [
  { label: '账号管理', name: 'accountManagement', weight: 5 },
  { label: '完税证明', name: 'dutypaidProofList', weight: 9 }
];
export const subMenusMap = [
  {
    label: '签约以及合同管理',
    name: 'contractInformationNaturalPerson',
    weight: 6
  },
  { label: '项目人员管理', name: 'projectPersonnelManageList', weight: 7 },
  { label: '推广管理', name: 'zoneList', weight: 8 }
];

const user = {
  state: {
    user: getStorage('user'),
    token: getToken(),
    otherInfo: null,
    enterpriseId: null,
    menus: [],
    projects: [],
    enums: getStorage('enums')
  },
  mutations: {
    SET_ENUMS: (state, enums) => {
      state.enums = enums;
      setStorage('enums', enums);
    },
    SET_USER: (state, user) => {
      state.user = user;
      setStorage('user', user);
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
      setToken(token);
    },
    SET_OTHER: (state, obj) => {
      state.otherInfo = obj;
      setStorage('otherInfo', obj);
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus;
      setStorage('menus', menus);
    },
    SET_ACCESS_PROJECT: (state, projects) => {
      state.projects = projects;
      setStorage('projects', projects);
    }
  },
  actions: {
    async InitUser(
      { commit, state, dispatch },
      data = { token: '', user: null }
    ) {
      let {
        enterpriseId,
        moreStatus,
        token,
        user,
        limitsOfAuthorityMenuList: menus,
        limitsOfAuthorityProjectList: accessProjects
      } = data;
      const { isMainAccountNumber } = user;
      const isMaster = +isMainAccountNumber === 1;

      if (!token || !user) {
        let hasToken = getToken();
        if (!hasToken) return Promise.reject('无用户信息');
        token = hasToken;
        user = getStorage('user');
        state.enterpriseId = enterpriseId;
      }
      // qiankun: 同步到子服务中
      qiankunStore.setGlobalState({
        token,
        isMaster,
        user,
        // 自定义enterprise，方便与供应商统一使用BI模板设置
        enterprise: {
          enterpriseName: user.userName,
          enterpriseId: user.enterpriseId
        }
      });
      setStorage('user', user);
      commit('SET_OTHER', moreStatus);
      commit('SET_TOKEN', token);
      commit('SET_USER', user);
      // 菜单 初始
      try {
        const { pdata } = await pageList({ pageNo: 1, pageSize: 1 });
        // 检查是否有客户档案 bug：#30149导致账号互顶的时候客户档案被重复push
        const crmListInBaseMenu = baseMenu.some(
          item => item.name === 'company-crm-list'
        );
        if (pdata.list.length && !crmListInBaseMenu) {
          baseMenu.push({
            label: '客户档案',
            name: 'company-crm-list',
            weight: 13
          });
        }
      } catch (e) {
        console.log('pageList err');
      }
      if (isMaster) {
        const asyncMenu = [];
        // 调用接口是否隐藏（提交材料管理菜单）
        // const {
        //   data: { data: isHidden }
        // } = await biTmplIsHidden();
        // const { biMenuStatus, cerMenuStatus } = isHidden;
        // //是否隐藏：1-隐藏，0-不隐藏（展示）
        // if (!biMenuStatus || !cerMenuStatus) {
        //   // BI模板设置和数字存证管理有一个展示则展示提交材料管理
        //   asyncMenu.push({
        //     label: '提交材料管理',
        //     name: 'bi-tmpl-list',
        //     weight: 10
        //   });
        // }

        //产品薛峰：永久显示提交材料管理菜单
        asyncMenu.push({
          label: '提交材料管理',
          name: 'task-review-log',
          weight: 10
        });
        const {
          data: { data: hasZsManage }
        } = await zsManageIsHidden();
        if (hasZsManage) {
          asyncMenu.push({
            label: '招商管理',
            name: 'zs-manage',
            weight: 11
          });
        }
        if (disIds.includes(+data.enterpriseId)) {
          commit('SET_MENUS', [baseMenu[0], baseMenu[2]]);
        } else {
          commit(
            'SET_MENUS',
            [...baseMenu, ...masterMenu, ...subMenusMap, ...asyncMenu].sort(
              (a, b) => {
                if (a.weight < b.weight) {
                  return -1;
                }
              }
            )
          );
        }
      } else {
        let accessRoles = [];
        menus.length &&
          menus.forEach(i => {
            accessRoles.push(subMenusMap[i['menuId'] - 1]);
          });
        if (disIds.includes(+data.enterpriseId)) {
          commit('SET_MENUS', [baseMenu[0], baseMenu[2]]);
        } else {
          commit('SET_MENUS', [...baseMenu, ...accessRoles]);
        }
        commit('SET_ACCESS_PROJECT', accessProjects || []);
      }

      dispatch('getBaseEnums');
      return Promise.resolve();
    },
    logOut({ commit }) {
      commit('SET_OTHER', null);
      commit('SET_TOKEN', null);
      commit('SET_USER', null);
      commit('SET_MENUS', []);
      commit('SET_ACCESS_PROJECT', []);
    },
    async getBaseEnums({ commit }) {
      const {
        data: { data }
      } = await baseConfig();
      commit('SET_ENUMS', data);
    }
  }
};

export default user;
